'use strict';

var _rollupPluginBabelHelpers = require('../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var PropTypes = require('prop-types');
var index = require('../IconSvg/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

var Button = /*#__PURE__*/function (_React$Component) {
  _rollupPluginBabelHelpers.inherits(Button, _React$Component);

  var _super = _rollupPluginBabelHelpers.createSuper(Button);

  function Button() {
    var _this;

    _rollupPluginBabelHelpers.classCallCheck(this, Button);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "calculateClassName", function () {
      var variant = _this.props.secondary ? 'secondary' : 'primary';
      var working = _this.props.working ? 'working' : '';
      var mainClassName;

      if (_this.props.small) {
        mainClassName = _this.props.destructive ? "ds-atom-btn-small-".concat(variant, "-destructive-normal") : "ds-atom-btn-small-".concat(variant, "-normal");
      } else if (_this.props.tiny) {
        mainClassName = _this.props.destructive ? "ds-atom-btn-tiny-".concat(variant, "-destructive-normal") : "ds-atom-btn-tiny-".concat(variant, "-normal");
      } else {
        mainClassName = _this.props.destructive ? "ds-atom-btn-".concat(variant, "-destructive-normal") : "ds-atom-btn-".concat(variant, "-normal");
      }

      return "".concat(_this.props.className, " ").concat(mainClassName, " ").concat(working);
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "handleClick", function (event) {
      event.preventDefault();
      if (!_this.props.working) _this.props.onSelect();
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "renderSpinner", function () {
      var _this$props = _this.props,
          children = _this$props.children,
          tiny = _this$props.tiny;
      return tiny ? /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement("span", {
        className: "ds-atom-btn-content"
      }, children), /*#__PURE__*/React__default['default'].createElement("span", {
        className: "ds-atom-btn-spinner"
      }, /*#__PURE__*/React__default['default'].createElement("title", null, "Loading"), /*#__PURE__*/React__default['default'].createElement("span", {
        className: "ds-atom-btn-spinner-dot"
      }, /*#__PURE__*/React__default['default'].createElement(index, {
        icon: "dot"
      })), /*#__PURE__*/React__default['default'].createElement("span", {
        className: "ds-atom-btn-spinner-dot"
      }, /*#__PURE__*/React__default['default'].createElement(index, {
        icon: "dot"
      })), /*#__PURE__*/React__default['default'].createElement("span", {
        className: "ds-atom-btn-spinner-dot"
      }, /*#__PURE__*/React__default['default'].createElement(index, {
        icon: "dot"
      })))) : /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement("span", {
        className: "ds-atom-btn-content"
      }, children), /*#__PURE__*/React__default['default'].createElement(index, {
        className: "ds-atom-btn-spinner-circle",
        icon: "spinner"
      }));
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "renderContent", function () {
      var _this$props2 = _this.props,
          children = _this$props2.children,
          icon = _this$props2.icon,
          small = _this$props2.small;
      return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, icon && small && /*#__PURE__*/React__default['default'].createElement(index, {
        icon: icon
      }), children);
    });

    return _this;
  }

  _rollupPluginBabelHelpers.createClass(Button, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          disabled = _this$props3.disabled,
          working = _this$props3.working,
          type = _this$props3.type;
      return (
        /*#__PURE__*/
        // eslint-disable-next-line react/button-has-type
        React__default['default'].createElement("button", {
          type: type,
          className: this.calculateClassName(),
          disabled: disabled,
          onClick: this.handleClick
        }, working ? this.renderSpinner() : this.renderContent())
      );
    }
  }]);

  return Button;
}(React__default['default'].Component);

_rollupPluginBabelHelpers.defineProperty(Button, "propTypes", {
  children: PropTypes__default['default'].node.isRequired,
  className: PropTypes__default['default'].string,
  destructive: PropTypes__default['default'].bool,
  disabled: PropTypes__default['default'].bool,
  icon: PropTypes__default['default'].string,
  onSelect: PropTypes__default['default'].func,
  secondary: PropTypes__default['default'].bool,
  small: PropTypes__default['default'].bool,
  tiny: PropTypes__default['default'].bool,
  working: PropTypes__default['default'].bool,
  type: PropTypes__default['default'].oneOf(['button', 'submit', 'reset'])
});

_rollupPluginBabelHelpers.defineProperty(Button, "defaultProps", {
  className: '',
  destructive: false,
  disabled: false,
  icon: undefined,
  onSelect: function onSelect() {},
  secondary: false,
  small: false,
  tiny: false,
  working: false,
  type: 'button'
});

module.exports = Button;
